import React, { useEffect, useState } from 'react'
import styles from './BootScreen.module.css'
import { translations } from '../../translations'
import { useTranslationUpdate } from '../../hooks/useTranslationUpdate'

interface BootScreenProps {
  onBootComplete: () => void
  isSystemReady: boolean
}

export default function BootScreen({ onBootComplete, isSystemReady }: BootScreenProps) {
  useTranslationUpdate()
  const [progress, setProgress] = useState(0)
  const [dots, setDots] = useState('')

  useEffect(() => {
    const dotsInterval = setInterval(() => {
      setDots(prev => prev.length >= 3 ? '' : prev + '.')
    }, 400)

    return () => clearInterval(dotsInterval)
  }, [])

  useEffect(() => {
    const progressInterval = setInterval(() => {
      setProgress(prev => {
        if (prev >= 60 && !isSystemReady) {
          return prev
        }
        if (isSystemReady && prev < 100) {
          return Math.min(prev + 10, 100)
        }
        if (prev < 60) {
          return prev + 5
        }
        return prev
      })
    }, 100)

    return () => clearInterval(progressInterval)
  }, [isSystemReady])

  useEffect(() => {
    if (progress >= 100) {
      setTimeout(() => {
        onBootComplete()
      }, 300)
    }
  }, [progress, onBootComplete])

  return (
    <div className={styles.bootScreen}>
      <div className={styles.content}>
        <div className={styles.logo}>
          <img src="/logo512_white.svg" alt="System Logo" className={styles.logoIcon} />
        </div>
        
        <div className={styles.progressContainer}>
          <div className={styles.progressBar}>
            <div 
              className={styles.progressFill} 
              style={{ width: `${progress}%` }}
            />
          </div>
          <p className={styles.loadingText}>
            {translations('boot_screen.starting')}{dots}
          </p>
        </div>
      </div>
    </div>
  )
}
